import { render, staticRenderFns } from "./menuBlock.vue?vue&type=template&id=cbe379f8&"
import script from "./menuBlock.vue?vue&type=script&lang=js&"
export * from "./menuBlock.vue?vue&type=script&lang=js&"
import style0 from "./menuBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports